import styled from 'styled-components';
import Check from '../../../assets/v2/DigitalSignage/TickDigital.svg';

import Video from '../../../assets/v2/DigitalSignage/DigitalVideo.mp4';
import { SectionParent } from '../../../components/StyledComponents';
import { Title } from '../HomePage/HomepageSectionOne';
import React from 'react';
import lottie, { AnimationItem } from 'lottie-web';

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #ecf6ff;
  padding-top: 2rem !important;
  padding-bottom: 5rem;
  background-size: contain;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 3rem !important;
  }
  width: 100%;
  display: grid;
`;

const SectionItemContainer = styled.div`
  grid-template-columns: repeat(2, 1fr);
  padding-left: 5rem;
  padding: 1rem 0;
  display: grid;
  @media (max-width: 768px) {
    padding-left: 0rem;
  }
`;
const HeroTitle = styled(Title)`
  margin-left: 2.5rem;
  margin-top: 1.67em;
  color: #131313;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: bold;
  text-align: center;
  font-size: 28px;

  @media (max-width: 768px) {
    margin-left: 0rem;
    text-align: center;
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    color: #ac93ff;
  }
`;

const GridLeft = styled.div`
  grid-column: span 1;
  /* padding-left: 7rem; */
  /* max-width: 50%; */
  position: relative;
  @media (max-width: 1100px) {
    padding-left: 0;
  }
  @media (max-width: 768px) {
    grid-column: span 2;
    padding-left: 0;
    padding-top: 2rem;
    /* max-width: 15rem; */
    justify-self: center;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 2rem;
  margin-left: 3rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  color: #ffffff;
  @media (max-width: 768px) {
    text-align: center;
    margin-left: 0rem;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    margin-bottom: -1rem;
    margin-left: 0;
  }
`;
const FormComponentLeft = styled.div`
  padding: 0rem 6rem;
  display: grid;
  grid-column: span 1;
  align-content: center;
  grid-column: span 1;
  justify-items: center;
  width: 100%;

  @media (max-width: 1440px) {
    padding: 0rem 3rem;
  }
  @media (max-width: 768px) {
    padding: 0rem 3rem;
    border-radius: 8px 8px 0px 0px;
    grid-column: span 2;
  }
  @media (max-width: 520px) {
    padding: 0rem;
  }
  @media (max-width: 400px) {
    padding: 0rem 2rem;
  }
`;

const FormComponentLeftList = styled.ul`
  /* margin-left: 40px; */
  padding-left: 0.5em;
  list-style: none;
`;

const FormComponentLeftListItem = styled.li`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 21px;
  @media (max-width: 1024px) {
    font-size: 16px;
  }
  @media (max-width: 768px) {
    font-size: 14px;
  }
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #298de5;
  background: url(${Check}) no-repeat;
  padding: 0.3em 0px 0.1em 30px;
  background-size: 18px;
  background-position-y: center;
  @media (max-width: 320px) {
    font-size: 12px;
  }
`;
const VideoContainer = styled.video`
  height: auto;
  width: 100%;
  box-shadow: rgba(72, 82, 108, 0.15) 0px 3px 18px 0px;
`;
export default class DigitalSectionThree extends React.Component<any, any> {
  animation?: AnimationItem;
  isCMounted = true;

  constructor(props: any) {
    super(props);
    this.animation = undefined;
  }

  scrollFunction = () => {
    // Get the header
    const header = document.getElementById('section-one-kiosk');

    if (header && this.isCMounted) {
      // Get the offset position of the navbar
      const containerTop = header!.offsetTop;
      // const containerBottom = header!.offsetTop + header!.clientHeight;
      const currentBottomPosition = window.pageYOffset + window.innerHeight;
      const currentTopPosition = window.pageYOffset;
      if (
        currentBottomPosition > containerTop &&
        currentTopPosition < containerTop
      ) {
        // lottie.play('animation-kiosk')
        const scrollPercent = (45 * currentTopPosition) / containerTop;
        const scrollRounded = Math.round(scrollPercent);
        this.animation!.goToAndStop(scrollRounded, true);
      } else {
        this.animation!.goToAndStop(45, true);
      }
    }
  };

  componentWillUnmount() {
    this.isCMounted = false;
  }
  componentDidMount() {
    this.isCMounted = true;
    window.onscroll = this.scrollFunction;
    this.animation = lottie.loadAnimation({
      name: 'animation-kiosk',
      container: document.getElementById('lottie-animation-digital')!,
      loop: true,
      renderer: 'svg',
      autoplay: false,
      animationData: require('../../lottieAnimations/Kiosk_Product_Mobile.json'),
    });
  }

  render() {
    return (
      <div>
        <SectionOne id="section-one-kiosk">
          <HeroTitle>Simple Digital Signage at Scale.</HeroTitle>
          <SectionItemContainer>
            <FormComponentLeft>
              <FormComponentLeftList>
                <FormComponentLeftListItem>
                  Real-Time Management.
                </FormComponentLeftListItem>
                <FormComponentLeftListItem>
                  True No-Touch Deployment.
                </FormComponentLeftListItem>
                <FormComponentLeftListItem>
                  Total Visibility and Control.
                </FormComponentLeftListItem>
                <FormComponentLeftListItem>
                  Android Telemetry Ready.
                </FormComponentLeftListItem>
              </FormComponentLeftList>
            </FormComponentLeft>
            <GridLeft>
              <VideoContainer muted={true} autoPlay={true} loop={true}>
                <source src={Video} type="video/mp4" />
              </VideoContainer>
            </GridLeft>
          </SectionItemContainer>
        </SectionOne>
      </div>
    );
  }
}
